import {Component, ElementRef, EventEmitter, Inject, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {BibliotecaFormularioComponent} from "../../../bibliotecaPjus/componentes/biblioteca-formulario.component";
import {ActivatedRoute, Router} from "@angular/router";
import {AlertaService} from "../../../bibliotecaPjus/services/alerta.service";
import {DeviceDetectorService} from "../../../core/services/device-detector.service";
import {TipoFormulario} from "../../../bibliotecaPjus/enums/enumGenerico.enum";
import {EnvioCnds} from "../../../aplicacao/models/envioCnds.model";
import {EnvioCndsService} from "../../../services/envio-cnds.service";
import {ParceriaService} from "../../../services/nova-parceria/parceria.service";
import {NgxSpinnerService, Spinner} from "ngx-spinner";
import {DocumentoEnum} from "../../../aplicacao/enum/documentos.enum";
import {TipoArquivoPermitido} from "../../../aplicacao/enum/tipo-arquivo-permitido.enum";
import {UploadDiretoS3Service} from "../../../core/services/upload-direto-s3.service";
import {environment} from "../../../../environments/environment";

@Component({
  selector: 'app-envio-documentos-v2',
  templateUrl: './envio-documentos.component.html',
  styleUrls: ['./envio-documentos.component.scss']
})
export class EnvioDocumentosComponent extends BibliotecaFormularioComponent<EnvioCnds> implements OnInit, OnDestroy {
  selectedFiles;
  nomeArquivo;
  progressoUpload: number | null = null;
  arquivoSelecionado: File | null = null;
  @Input() envioAutomatico = false;
  @Output() retorno = new EventEmitter();
  @Output() limparTipoDoc = new EventEmitter();
  @Input() tipoDocumento = DocumentoEnum.getTypes().filter(tipo =>
    ['Oficio', 'OutrosDocumentosRelevantes', 'PlanilhaDeCalculo', 'CopiaPrecatorio'].includes(tipo.key)
  );
  @ViewChild('fileInput') fileInput: ElementRef<HTMLInputElement>;
  @Input() propostaId: string = '';
  @Input() documentoEnvioAceiteProposta: string = '';
  @Input() msgAlertaAtivo = false;
  @Input()
  set envioDocumento(value: any) {
    this.tratarEnvioDocumento(value);
  }

  get envioDocumento(): any {
    return null; //this._envioDocumento;
  }

  tratarEnvioDocumento(value: any) {
    if(value) {
      const valorTratado = String(value).replace(/0$/, '');
      this.fileInput.nativeElement.value = '';
      this.fileInput.nativeElement.click();
      this.form.controls.tipoDocumento.setValue(valorTratado);
      this.form.controls.nomeExterno.setValue(valorTratado);
    }
  }
  constructor(
    protected router: Router,
    protected route: ActivatedRoute,
    protected alertaService: AlertaService,
    protected deviceDetectorService: DeviceDetectorService,
    protected envioCndsService: EnvioCndsService,
    protected parceriaService: ParceriaService,
    protected ngxSpinnerService: NgxSpinnerService,
    protected uploadDiretoS3Service: UploadDiretoS3Service,
    ) {
    super(
      router,
      route,
      alertaService,
      envioCndsService,
      ['Novo envio de Documento', 'Editar envio de Documento'],
      ['Documento enviado com sucesso.', 'Documento editada com sucesso.']
    );
    const novaProposta = this.service.criar();
    this.loaded(novaProposta, TipoFormulario.Criar);
  }

  ngOnInit() {
    super.ngOnInit();
  }


  antesEnviar(): void {
    this.fc.propostaId.setValue(this.propostaId);
    this.validarFormulario = false;
    if (this.form.valid){
      this.ngxSpinnerService.show();
      this.validarFormulario = true;
    }
  }

  uploadArquivo(event: Event): void {
    const input = event.target as HTMLInputElement;

    if (!input.files || input.files.length === 0) {
      this.fileInput.nativeElement.value = '';
      return;
    }

    const file = input.files[0];
    this.msgAlerta(file);

    if (environment.uploadDiretoS3) {
      this.prepararArquivoDireto(file);
      input.value = '';
      return;
    }

    const reader = new FileReader();
    reader.onload = (e) => {
      if (typeof e.target?.result === 'string') {
        const base64String = e.target.result.split(',').pop();
        this.nomeArquivo = file.name;
        this.form.controls.base64.setValue(base64String);
        this.form.controls.extensaoArquivo.setValue(
          file.name.split('.').pop()?.toLowerCase()
        );

        if (this.envioAutomatico) {
          this.enviar();
        }
      }
    };

    reader.readAsDataURL(file);
    input.value = '';
  }

  /**
   * No modo direto, o clique em "Enviar" (ngSubmit) dispara o upload ao S3 em vez
   * do envio do base64 pela BFF. Com a flag desligada, mantém o fluxo original.
   */
  enviar(): void {
    // Sem propostaId não há como vincular o documento — evita o "envio silencioso"
    // que não acontecia (form inválido) e não dava nenhum retorno ao usuário.
    if (!this.propostaId) {
      this.alertaService.erro('Não foi possível identificar a proposta. Recarregue a página e tente novamente.');
      return;
    }

    if (environment.uploadDiretoS3) {
      this.enviarDireto();
      return;
    }
    super.enviar();
  }

  /**
   * Apenas prepara o arquivo selecionado (valida e guarda); o envio acontece no
   * clique em "Enviar". Em envioAutomatico, dispara o upload na sequência.
   */
  private prepararArquivoDireto(file: File): void {
    const extensao = file.name.split('.').pop()?.toLowerCase() ?? '';

    const maxFileSize = 200 * 1024 * 1024;
    if (file.size > maxFileSize) {
      this.arquivoSelecionado = null;
      this.alertaService.erro('O documento excede o tamanho máximo permitido de 200 MB.');
      this.limparTipoDoc.emit();
      return;
    }

    const extensaoValida = Object.values(TipoArquivoPermitido)
      .map(value => String(value).toLowerCase())
      .includes(extensao);
    if (!extensaoValida) {
      this.arquivoSelecionado = null;
      this.alertaService.erro('O documento enviado não está em um dos formatos aceitos (PDF, JPG, JPEG, PNG).');
      this.limparTipoDoc.emit();
      return;
    }

    this.arquivoSelecionado = file;
    this.nomeArquivo = file.name;
    this.form.controls.extensaoArquivo.setValue(extensao);

    if (this.envioAutomatico) {
      this.enviarDireto();
    }
  }

  /**
   * Envio direto ao S3 via URL pré-assinada (multipart), sem trafegar o base64
   * pela BFF/Esteira.
   */
  private enviarDireto(): void {
    const file = this.arquivoSelecionado;
    if (!file) {
      this.alertaService.erro('Selecione um arquivo para enviar.');
      return;
    }

    const tipoDocumento = this.form.controls.tipoDocumento.value;
    if (!tipoDocumento) {
      this.alertaService.erro('Selecione o tipo de documento antes de enviar.');
      return;
    }

    const extensao = file.name.split('.').pop()?.toLowerCase() ?? '';
    this.progressoUpload = 0;
    this.ngxSpinnerService.show();

    this.uploadDiretoS3Service.enviar(file, this.propostaId, tipoDocumento, extensao).subscribe({
      next: (progresso) => {
        this.progressoUpload = progresso;
      },
      error: () => {
        this.progressoUpload = null;
        this.ngxSpinnerService.hide();
        this.alertaService.erro('Falha ao enviar o documento. Tente novamente.');
      },
      complete: () => {
        this.progressoUpload = null;
        this.arquivoSelecionado = null;
        this.alertaService.sucesso('Documento enviado com sucesso.');
        this.atualizarAposEnvioDireto();
      }
    });
  }

  private atualizarAposEnvioDireto(): void {
    this.parceriaService.get(this.propostaId).subscribe(result => {
      this.parceriaService.model.documento = result.documento;
      this.carregando = false;
      this.nomeArquivo = null;
      this.validarFormulario = true;
      this.form.reset();
      this.ngxSpinnerService.hide();
      if (this.envioAutomatico) {
        this.retorno.emit();
      }
    });
  }


  msgAlerta(element): void {
    if(this.msgAlertaAtivo) {
      const maxFileSize = 200 * 1024 * 1024;
      if (element.size > maxFileSize) {
        this.alertaService.erro('O documento excede o tamanho máximo permitido de 200 MB.');
        this.selectedFiles = null;
        this.limparTipoDoc.emit();
        return;
      }
      const docValido = element.name.split('.').pop().toLowerCase() ? Object.values(TipoArquivoPermitido).map(String).
      map(value => value.toLowerCase()).
      includes(element.name.split('.').pop().toLowerCase()) : null;
      if(!docValido) {
        this.alertaService.erro('O documento enviado não está em um dos formatos aceitos (PDF, JPG, JPEG, PNG).');
        this.selectedFiles = null;
        this.limparTipoDoc.emit();
        return;
      }


    }
  }

  depoisEnviar(model: EnvioCnds) {
    super.depoisEnviar(model);
    this.parceriaService.get(this.propostaId).subscribe(result => {
      this.parceriaService.model.documento = result.documento;
      this.carregando = false;
      this.nomeArquivo = null;
      this.validarFormulario = true;
      this.form.reset();
      this.ngxSpinnerService.hide();
      if(this.envioAutomatico) {
        this.retorno.emit();
      }
    });
    this.navegar = false;

  }

  tipoDocumentoSelecionado(ev): void {
    this.form.controls.tipoDocumento.setValue(ev);
  }
}
